import { FelaCSS } from '@bridebook/ui';
import { ISharedTypes as IStyleProps } from './content-container';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = ({ noPaddingTop, noPaddingBottom }: IStyleProps): IStyles => ({
  wrapper: {
    paddingTop: noPaddingTop ? undefined : '24px',
    paddingBottom: noPaddingBottom ? undefined : '32px',

    maxWidthTabletSm: {
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: noPaddingTop ? undefined : '24px',
      paddingBottom: noPaddingBottom ? undefined : '24px',
    },
  },
});

export default styles;
